var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,68.000000) scale(0.100000,-0.100000)",
  fill: "#fb9912",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M141 658 c-56 -29 -82 -76 -89 -164 -4 -58 -7 -64 -25 -62 -11 2 -22 -3 -24 -9 -3 -8 5 -13 21 -13 l26 0 0 -190 0 -190 -28 -13 c-25 -11 -22 -12 41 -15 37 -2 96 -2 130 0 57 3 60 8 12 23 -13 4 -15 34 -15 194 l0 190 50 3 c28 2 50 7 50 12 0 6 -23 9 -50 7 l-50 -2 0 81 c0 87 19 150 45 150 27 0 38 -49 21 -92 l-14 -38 37 0 c55 0 83 24 79 67 -4 50 -41 76 -115 81 -46 3 -67 -1 -102 -20z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M435 431 c-160 -72 -168 -323 -13 -402 46 -24 129 -35 182 -25 39 8 106 59 106 82 0 19 -16 18 -24 -1 -10 -26 -69 -55 -113 -55 -90 0 -132 84 -120 240 10 120 31 160 86 160 45 0 76 -82 50 -132 -9 -16 -8 -23 2 -29 20 -13 70 -1 93 22 24 22 27 79 5 105 -43 52 -177 71 -254 35z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M799 141 c-33 -27 -33 -95 0 -122 32 -27 77 -24 106 6 31 30 32 73 4 109 -25 32 -75 35 -110 7z"
}));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "93.000000pt",
    height: "68.000000pt",
    viewBox: "0 0 93.000000 68.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.99ceee736dfd70aeb1c768a06f1cd57a.svg";
export { ForwardRef as ReactComponent };